interface IndeterminateProgressProps {
  className?: string;
}

function IndeterminateProgress({ className }: IndeterminateProgressProps) {
  return (
    <div className={className}>
      {/* Track uses muted surface; bar uses azure (visible in light + dark — not navy #193057). */}
      <div className="bg-gray-medium h-0.5 w-full overflow-hidden transition-all duration-100">
        <div className="left-right animate-progress-indeterminate bg-azure h-full w-full"></div>
      </div>
    </div>
  );
}

export default IndeterminateProgress;
